export var getFixedCellSize = size => typeof size === 'number' ? {
  minWidth: "".concat(size, "px"),
  width: "".concat(size, "px"),
  maxWidth: "".concat(size, "px")
} : {};
//# sourceMappingURL=FormLineItems.types.js.map